import { connect } from "react-redux";
import './css/DataPanel.css';
import {useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useTable } from "react-table";
import { csvFromString } from "mascot-vis";
import { addToStack } from "./Util";
import { immerable } from "immer";
import { useSearchParams } from 'react-router-dom';


function DataPanel (props) {

    const [activeTbl, setActiveTbl] = useState(null);
    const [dataScopeRows, setDataScopeRows] = useState([]);
    const [dataScopeInfo, setDataScopeInfo] = useState(null);
    const inputFile = useRef(null);

    const [queryParameters] = useSearchParams();
    const [urlDataset, setUrlDataset] = useState(null);

    const importDataset = useCallback((string, dname) => {
        try {
            //TODO: need to check if string is valid csv
            let tbl = csvFromString(string, dname);
            let ds = props.datasets.slice();
            ds.push(tbl);
            props.loadDataset(ds);
            setActiveTbl(tbl);
        } catch (err) {
            console.warn("Invalid data file: " + dname);
        }
    }, [props]); 

    useEffect(() => {
        let ds = queryParameters.get("dataset");
        if (ds && !urlDataset) {
            setUrlDataset(ds);
            fetch("/app/csv/" + ds + ".csv")
                .then(response => {
                    return response.text()
                })
                .then(result => {
                    importDataset(result, ds);
                });
        }
    }, [queryParameters, urlDataset, importDataset])
    
    const cols = useMemo(() => {
        if (activeTbl === null) return [{Header: " ", accessor: " "}];
        else {
            let fields = activeTbl.fields;
            let result = [];
            for (let f of fields) {
                //if (f === "atlas_rowId") continue;
                result.push({
                    Header: f === "atlas_rowId" ? "Row ID" : f,
                    accessor: f,
                    filter: "equals",
                    Cell: ({value}) => activeTbl.getRawValue(f, value)
                })
            }
            return result;
        }
    }, [activeTbl])

    const data = useMemo(() => {
        if (activeTbl === null) return [{col: 1}];
        else {
            return dataScopeRows.slice(0, 500);
            //return activeTbl.data.length > 500 ? activeTbl.data.slice(0, 500) : activeTbl.data;
            //return activeTbl.data;
        }
    }, [activeTbl, dataScopeRows])

    const initState = { hiddenColumns: ['atlas_rowId'] };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({columns: cols, data: data, initialState: initState});

    const importBtnClicked = function() {
        inputFile.current.click();
    }

    const fileChanged = function(e) {
        e.stopPropagation();
        e.preventDefault();
        let f = e.target.files[0];
        const reader = new FileReader();
        reader.onload = function() {
            addToStack(props.scene, props.datasets, props.undoStack);
            let tbl = csvFromString(reader.result, f.name);
            let ds = props.datasets.slice();
            ds.push(tbl);
            props.loadDataset(ds);
            setActiveTbl(tbl);
            // console.log("data imported", props.selected);
        }
        if (f)
            reader.readAsText(f);
    }

    const getHeaderIcon = function(field) {
        if (!activeTbl)
            return <span></span>;
        switch (activeTbl.getFieldType(field)) {
            case "string":
                return <img src="/app/icons/string.png" alt="(string) " width="20px" height="10px" style={{"margin":"0 4px 2px 0"}}></img>;
            case "date":
                return <img src="/app/icons/date.png" alt="(date) " width="15px" style={{"margin":"0 3px 2px 0"}}></img>;
            default:
                return <img src="/app/icons/number.png" alt="(number) " width="12px" height="12px" style={{"margin":"0 2px 3px 0"}}></img>;
        }
    }

    useEffect(() => {
        if (!props.datasets || props.datasets.length === 0) {
            setActiveTbl(null);
            //setAllFilters([]);
            setDataScopeRows([]);
            setDataScopeInfo(null);
            return;
        }
        if (props.selected.length === 0 && !props.directSelected) {
            setActiveTbl(props.datasets[0]);
            //setAllFilters([]);
            setDataScopeRows(props.datasets[0].data);
            setDataScopeInfo(null);
        } else if (props.selected.length > 0) {
            const item = props.scene.getItem(props.selected[0]);
            if (!item || item.type === "axis" || item.type === "legend" || immerable.type === "gridlines") {
                setActiveTbl(props.datasets[0]);
                //setAllFilters([]);
                setDataScopeRows([]);
                setDataScopeInfo(null);
                return;
            }
            if (item.dataScope) {
                setActiveTbl(item.dataScope.dataTable);
                //const filters = item.dataScope.filters;
                // let fs = [];
                // for (let f in item.dataScope.filters) {
                //     // let o = {};
                //     // o[f] = item.dataScope.filters[f];
                //     fs.push({id: f, value: item.dataScope.filters[f]});
                // }
                // console.log(fs);
                //setAllFilters(fs);
                // setFilter(f, filters[f]);
                setDataScopeRows(item.dataScope.tuples);
                setDataScopeInfo("Selected " + item.type + " has " + item.dataScope.numTuples +  " attached data rows");
            } else {
                setActiveTbl(null);
                //setAllFilters([]);
                setDataScopeRows([]);
                setDataScopeInfo("Selected " + item.type + " has no attached data");
            } 
        } else if (props.directSelected) {
            const itm = props.scene.getItem(props.directSelected);
            if (!itm) {
                setActiveTbl(props.datasets[0]);
                //setAllFilters([]);
                setDataScopeRows([]);
                setDataScopeInfo(null);
            }
            if (itm.dataScope) {
                setActiveTbl(itm.dataScope.dataTable);
                // const filters = itm.dataScope.filters;
                // for (let f in filters) {
                //     setFilter(f, filters[f]);
                // }
                // let fs = [];
                // for (let f in itm.dataScope.filters) {
                //     // let o = {};
                //     // o[f] = item.dataScope.filters[f];
                //     fs.push({id: f, value: itm.dataScope.filters[f]});
                // }
                // setAllFilters(fs);
                setDataScopeRows(itm.dataScope.tuples);
                setDataScopeInfo("Selected " + itm.type + " has " + itm.dataScope.numTuples +  " attached data rows");
            } else {
                setActiveTbl(null);
                //setAllFilters([]);
                setDataScopeRows([]);
                setDataScopeInfo("Selected " + itm.type + " has no attached data");
            } 
        }
    }, [props.selected, props.directSelected, props.scene, props.datasets]);

    return (
        <div id="dataPanel">
            <div id="datasetInfo">
                {props.datasets.map(d => 
                <div className={activeTbl && activeTbl.id === d.id ? "activeTableTab" : "tableTab"} key={d.id} onClick={(e) => setActiveTbl(d)}>
                    {d.name + " (" + d.getRowCount() + " rows)"}
                </div>)}
                <button id="csvBtn" onClick={importBtnClicked}>Import Data</button>
                <input type='file' id='file' ref={inputFile} style={{display: 'none'}} accept=".csv" onChange={fileChanged}/>
            </div>
            <div id="dataScopeInfo" style={{display: dataScopeInfo ? "block" : "none"}}>
                {dataScopeInfo ? dataScopeInfo : ""}
            </div>
            <div id="tableDiv">
                <table id="dataTable" {...getTableProps()}>
                        <thead>
                            {// Loop over the header rows
                                headerGroups.map(headerGroup => (
                                    // Apply the header row props
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {// Loop over the headers in each row
                                            headerGroup.headers.map(column => (
                                                // Apply the header cell props
                                                <th {...column.getHeaderProps()}>
                                                    {getHeaderIcon(column.Header)}
                                                    {// Render the header
                                                        column.render('Header')
                                                    }
                                                </th>
                                            ))}
                                    </tr>
                                ))}
                        </thead>
                        {/* Apply the table body props */}
                        <tbody {...getTableBodyProps()}>
                            {// Loop over the table rows
                                rows.map(row => {
                                    // Prepare the row for display
                                    prepareRow(row)
                                    return (
                                        // Apply the row props
                                        <tr {...row.getRowProps()}>
                                            {// Loop over the rows cells
                                                row.cells.map(cell => {
                                                    // Apply the cell props
                                                    return (
                                                        <td {...cell.getCellProps()}>
                                                            {// Render the cell contents
                                                                cell.render('Cell')}
                                                        </td>
                                                    )
                                                })}
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table> 
            </div>
            
        </div>
    );
}

const mapStateToProps = state => ({
    selected: state.canvas.selected,
    directSelected: state.canvas.directSelected
});

export default connect(mapStateToProps)(DataPanel);